import React, { FC } from 'react';

import { DefaultTheme } from 'styled-components';

import { BaseStyle, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { CountryCode } from '~/core/enums';
import { useIsWebviewHeadless } from '~/core/hooks/useIsWebview';
import { PlayoffSeriesInfo } from '~/core/types';
import { FormatPlayoffSeriesInfo, getEnvironmentAwareHref } from '~/core/utils';

import { Config } from '../../hooks/configType';
import { PlayoffSeries } from '../types';

import { HSBSeries, SeriesStatus, Team, TransparentSlideCover } from './styles';

type Props = {
    series: PlayoffSeries;
    config?: Config;
    broadcastCountryCode: CountryCode;
    theme: DefaultTheme;
    language?: ShortCodeEnums.Language;
};

const SeriesSlide: FC<Props> = ({ series, theme, language }) => {
    const isWebview = useIsWebviewHeadless();
    const isDark = theme === BaseStyle.DarkTheme;

    const playoffSeriesInfo: PlayoffSeriesInfo = {
        topSeedAbbrev: series.topSeed.abbrev,
        topSeedWins: series.topSeed.wins,
        bottomSeedAbbrev: series.bottomSeed.abbrev,
        bottomSeedWins: series.bottomSeed.wins,
        neededToWin: series.neededToWin,
    };

    return (
        <HSBSeries href={getEnvironmentAwareHref(series.seriesLink, isWebview, language)}>
            {/* The TransparentSlideCover only shows while hovering on the slide */}
            <TransparentSlideCover />
            <SeriesStatus>
                <FormatPlayoffSeriesInfo playoffSeriesInfo={playoffSeriesInfo} />
            </SeriesStatus>
            <Team $isLeftTeam>
                <TeamDisplay
                    logoUrlOverride={isDark ? series.bottomSeed.darkLogo : series.bottomSeed.logo}
                    team={{ triCode: series.bottomSeed.abbrev }}
                    displayName={true}
                    displayTricode={true}
                    displayLogo={true}
                />
            </Team>
            <Team $isLeftTeam={false}>
                <TeamDisplay
                    logoUrlOverride={isDark ? series.topSeed.darkLogo : series.topSeed.logo}
                    team={{ triCode: series.topSeed.abbrev }}
                    displayName={true}
                    displayTricode={true}
                    displayLogo={true}
                />
            </Team>
        </HSBSeries>
    );
};

export default SeriesSlide;
